module.exports = __webpack_public_path__ + "assets/img/7_688.ad600a73.jpg";